export default {"src":"/_next/static/media/lg_logo.f56083b4.svg","height":77,"width":176};